"use strict";

import angular from "angular";

import template from "./header-top-nav.component.html";
import "./themes/header-top-nav.component.scss";
import "./themes/header-top-nav-dark.component.scss";

import { UserDataAdapter } from "../../../presentation/adpters/UserDataAdapter";
import { RolesUtils } from "../../../utils/roles/roles";
import {
    customerUsers,
    nucontersUsers
} from "../../../utils/users-roles/users-roles";

export class HeaderTopNavComponent {
    constructor(
        $scope,
        $state,
        $stateParams,
        $rootScope,
        LayoutService,
        CentralSidenavService,
        UserProfileSidenavService,
        StepsControl
    ) {
        this.$scope = $scope;
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.$rootScope = $rootScope;

        this.LayoutService = LayoutService;
        this.CentralSidenavService = CentralSidenavService;
        this.UserProfileSidenavService = UserProfileSidenavService;
        this.StepsControl = StepsControl;

        this.$rootScope.searchText = "";
        this.user = new UserDataAdapter().user();

        this.isBusinessUser = this.user.roles.indexOf("Empresa") > -1;
    }

    $onInit() {
        this.$rootScope.$on(
            "SET_NANDA_NOTIFICATION",
            (event, status, scope) => {
                this.onReceiveNotification(event, status, scope);
                this.$scope.$applyAsync();
            }
        );

        this.$rootScope.$on(
            "$locationChangeSuccess",
            (event, next, current) => {
                if (current !== next) {
                    this.$rootScope.searchText = "";
                }
            }
        );
    }

    goToMain() {
        if (this.userIs(customerUsers))
            this.$state.go(
                "nucont.accounting.overview.portfolio.companies.resume",
                {
                    accountingId:
                        this.$stateParams.accIdReference ||
                        this.$state.params.accIdReference ||
                        this.$stateParams.accountingId ||
                        this.$state.params.accountingId
                }
            );
        if (this.userIs(nucontersUsers))
            this.$state.go("nucont.accountings.customers", {
                accountingId:
                    this.$stateParams.accIdReference ||
                    this.$state.params.accIdReference ||
                    this.$stateParams.accountingId ||
                    this.$state.params.accountingId
            });
    }

    goToOverview() {
        if (this.$state.current.name.indexOf("group") >= 0) {
            this.$state.go(
                "nucont.accounting.overview.portfolio.groups.resume"
            );
        } else {
            const state = this.user.roles.includes("Empresa")
                ? "nucont.accounting.overview.portfolio.companies.register"
                : "nucont.accounting.overview.portfolio.companies.resume";
            this.$state.go(state, {
                accountingId:
                    this.$stateParams.accIdReference ||
                    this.$state.params.accIdReference ||
                    this.$stateParams.accountingId ||
                    this.$state.params.accountingId
            });
        }
    }

    userIs(roles) {
        return RolesUtils.userIsInRole({ roles });
    }

    onReceiveNotification(event, status, scope) {}

    onSearch() {
        this.$rootScope.$broadcast("onTypeHeaderInput", {
            searchText: this.$rootScope.searchText
        });
    }

    onOpenCentralHelper() {
        this.CentralSidenavService.open(0);
    }

    onOpenCentralNews() {
        this.CentralSidenavService.open(1);
    }

    onOpenProfileMenu() {
        this.UserProfileSidenavService.open();
    }

    getInitials(name) {
        return !name
            ? ""
            : name
                  .replace(/[^\w\s]/gi, "")
                  .split(" ")
                  .map((word, index, arr) =>
                      index == 0 || (arr.length > 1 && index == arr.length - 1)
                          ? word.charAt(0)
                          : ""
                  )
                  .join("")
                  .toUpperCase();
    }

    onIndicateAndWin() {
        window.open("https://pages.nucont.com/indicacao", "_blank");
    }

    isIndiqueGanheVisible() {
        const currentState = this.$state.current.name;
        return (
            currentState.indexOf("nucont.accounting.overview.dashboard") > -1 ||
            currentState.indexOf("nucont.accounting.overview.portfolio") > -1
        );
    }
}

HeaderTopNavComponent.$inject = [
    "$scope",
    "$state",
    "$stateParams",
    "$rootScope",
    "LayoutService",
    "CentralSidenavService",
    "UserProfileSidenavService",
    "StepsControl"
];

const name = "headerTopNavComponent";
const def = {
    controller: HeaderTopNavComponent,
    bindings: {},
    template
};
angular.module("nucont.shared").component(name, def);
export default { name, ...def };
